// extracted by mini-css-extract-plugin
module.exports = {"empty":"CustomEmpty_empty__3FiJk","text":"CustomEmpty_text__3LAl5"};